'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAsyncAction = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _reduxActions = require('redux-actions');

var _makeRequestActionTypes = require('./operators/makeRequestActionTypes');

var getActionTypes = function getActionTypes(actionName, actionTypes) {
  if (actionTypes) return actionTypes;

  return (0, _makeRequestActionTypes.makeRequestActionTypes)(actionName);
};

var createAsyncAction = exports.createAsyncAction = function createAsyncAction(_ref) {
  var requestFn = _ref.requestFn,
      actionName = _ref.actionName,
      _ref$actionTypes = _ref.actionTypes,
      actionTypes = _ref$actionTypes === undefined ? null : _ref$actionTypes,
      toRecordFn = _ref.toRecordFn,
      _ref$successMetaActio = _ref.successMetaActionCreator,
      successMetaActionCreator = _ref$successMetaActio === undefined ? function () {
    return {};
  } : _ref$successMetaActio,
      _ref$failureMetaActio = _ref.failureMetaActionCreator,
      failureMetaActionCreator = _ref$failureMetaActio === undefined ? function () {
    return {};
  } : _ref$failureMetaActio;

  if (!actionName && !actionTypes || actionName && actionTypes) {
    throw new Error('Either an actionName or actionTypes are required to create an async action');
  }

  if (!requestFn || typeof requestFn !== 'function') {
    throw new Error('Invalid requestFn "' + requestFn + '"');
  }

  if (!toRecordFn || typeof toRecordFn !== 'function') {
    throw new Error('Invalid toRecordFn "' + toRecordFn + '"');
  }

  var _getActionTypes = getActionTypes(actionName, actionTypes),
      STARTED = _getActionTypes.STARTED,
      SUCCEEDED = _getActionTypes.SUCCEEDED,
      FAILED = _getActionTypes.FAILED;

  var fetchStarted = (0, _reduxActions.createAction)(STARTED);
  var fetchSucceed = (0, _reduxActions.createAction)(SUCCEEDED, function (payload) {
    return payload;
  }, successMetaActionCreator);
  var fetchFailed = (0, _reduxActions.createAction)(FAILED, function (payload) {
    return payload;
  }, failureMetaActionCreator);

  return function (requestArgs) {
    return function (dispatch) {
      var isObject = (typeof requestArgs === 'undefined' ? 'undefined' : _typeof(requestArgs)) === 'object' && !Array.isArray(requestArgs);

      if (requestArgs && !isObject) {
        throw new Error('Invalid argument "' + requestArgs + '"');
      }

      dispatch(fetchStarted({ requestArgs: requestArgs }));
      var promise = requestFn(requestArgs).then(function (resp) {
        return dispatch(fetchSucceed({ requestArgs: requestArgs, data: toRecordFn(resp) }));
      }, function (error) {
        return dispatch(fetchFailed({ requestArgs: requestArgs, error: error }));
      });
      promise.done();
      return promise;
    };
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-clients/static-1.4266/js/action-creators/createAsyncAction.js
// module id = 268
// module chunks = 2 3